import React from "react";
import Card from "../AppointmentCard";

export class TreatmentModal extends React.Component {
  state = {
    dataList: [],
    isLoading: false,
  };

  componentDidMount() {
    if (this.props.isOpen) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.fetchData();
    }
  }

  fetchData = () => {
    const { onFetchData } = this.props;
    if (onFetchData) {
      this.setState({ isLoading: true });
      onFetchData()
        .then((data) => {
          this.setState({
            dataList: data || [],
            isLoading: false,
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.setState({
            dataList: [],
            isLoading: false,
          });
        });
    }
  };

  handleRowClick = (item, index) => {
    const { onSelectItem } = this.props;
    if (onSelectItem) {
      onSelectItem(item, index);
    }
  };

  render() {
    const {
      isOpen,
      onClose,
      title,
      headerDetails,
      customerInfo,
      renderRowCells,
      noDataMessage,
    } = this.props;
    const { dataList, isLoading } = this.state;

    if (!isOpen) return null;

    return (
      <div className="treatment-modal-overlay" onClick={onClose}>
        <div
          className="treatment-modal-container"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="treatment-modal-header">
            <div className="treatment-title-container">
              <h3>{title || "Select Item"} </h3>
              <p>{customerInfo.name}</p>
            </div>
            <button type="button" className="close-modal-btn" onClick={onClose}>
              ×
            </button>
          </div>

          <div className="card-list">
            <div className="card-list__container">
              {dataList.map((card, index) => (
                <Card
                  key={card.id}
                  title={card.title}
                  data={card.data}
                  cardNo={index + 1}
                  totalCards={dataList.length}
                />
              ))}
            </div>
          </div>
          {/* Data Table */}
          {/* <div className="treatment-table-wrapper">
            {isLoading ? (
              <div className="no-treatments-found">
                <div className="loading-spinner"></div>
                <p>Loading...</p>
              </div>
            ) : dataList.length > 0 ? (
              <table className="treatment-table">
                <thead>
                  <tr>
                    {headerDetails.map((header, index) => (
                      <th
                        key={index}
                        className={header.className || header.divClass || ""}
                      >
                        {header.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dataList.map((item, index) => (
                    <tr
                      key={index}
                      className="treatment-row"
                      style={{ cursor: "default" }}
                      //   onClick={() => this.handleRowClick(item, index)}
                    >
                      {renderRowCells(item, index)}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="no-treatments-found">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35" />
                </svg>
                <p>{noDataMessage || "No data available"}</p>
              </div>
            )}
          </div> */}
        </div>
      </div>
    );
  }
}
